<div class="facet">
    <app-expansion-panel #panel [headerClickable]="true" [expanded]="expandPanel" (changed)="onPanelChange($event)">
        <h6 class="facet__title" expansion-title [class.facet__title--no-margin]="!panel.animating && !panel.expanded">
            {{ 'filterpage.show_only' | translate }}
        </h6>
        <span expansion-icon [innerHTML]="icons.chevronDownIcon | safe: 'html'"></span>
        <ul class="facet__list">
            <li *ngFor="let filter of facetFilters">
                <!-- <app-fade-in> -->
                    <label class="facet__list-item animate-fade-in">
                        <span class="facet__label-text"> {{ filter.label }} ({{ filter.item.count }}) </span>
                        <div class="checkbox">
                            <input type="checkbox" [checked]="filter.item.selected" (change)="handleChange(filter)" />
                            <span class="checkbox__checkmark" [innerHTML]="icons.checkmarkIcon | safe: 'html'"></span>
                        </div>
                    </label>
                <!-- </app-fade-in> -->
            </li>
        </ul>
    </app-expansion-panel>
</div>
